/* Filtri i gjenerates dhe i pjeses per rezultatet e Bacit.
   Problemi qe zgjidh: kerkimi i Shopify-t kthen edhe F20 (2011–2014) kur klienti tha
   F20 Facelift, dhe kthen front lip kur klienti kerkoi parakolp. Asnjera nuk i hyn.
   Testet, ne kete rend:
     1. kodi     — titulli duhet ta permbaje kodin e gjenerates (f20, w205, g20...)
     2. facelift — nese gjenerata ka dy versione, LCI/Facelift duhet te perputhet sakte
     3. vitet    — vitet ne titull duhet te mbivendosen me vitet e gjenerates (pa toleranca)
     4. pjesa    — nese jane dhene fjalet e pjeses, titulli duhet ta permbaje njeren
   Nese pas filtrit nuk mbetet asgje, kthen liste boshe — Baci e thote hapur, nuk zevendeson.
   3 shtator: kodi krahasohet si fjale e plote — "golf 7" nuk i merrte edhe pjeset e "golf 7.5";
   nje titull pa "Facelift" po me vite qe i mbulojne te dyja versionet (2014–2022) i hyn edhe facelift-it. */
(function () {
  function norm(s) {
    return (s || '').toLowerCase().replace(/ë/g, 'e').replace(/ç/g, 'c').replace(/\s+/g, ' ');
  }
  function years(title) {
    var m = norm(title).match(/(19|20)\d{2}/g);
    if (!m || !m.length) return null;
    var f = parseInt(m[0], 10);
    var t = m.length > 1 ? parseInt(m[1], 10) : 9999;
    if (t < f) t = 9999;
    return { f: f, t: t };
  }
  /* Kodi si fjale e plote: "golf 7" nuk eshte "golf 7.5", "b8" nuk eshte "b8.5", "g20" nuk eshte "g200". */
  function hasCode(n, code) {
    var i = 0;
    while ((i = n.indexOf(code, i)) > -1) {
      var before = n.charAt(i - 1), after = n.charAt(i + code.length), after2 = n.charAt(i + code.length + 1);
      var okB = !before || !/[a-z0-9]/.test(before);
      var okA = !after || !(/[0-9]/.test(after) || ((after === '.' || after === ',') && /[0-9]/.test(after2)));
      if (okB && okA) return true;
      i += code.length;
    }
    return false;
  }
  function isFacelift(s) {
    var n = ' ' + norm(s) + ' ';
    return n.indexOf('facelift') > -1 || n.indexOf(' lci ') > -1;
  }
  window.BaciFilter = function (products, chosen, code, twoVariants, partWords) {
    if (!products || !products.length) return [];
    var wantFL = chosen ? isFacelift(chosen.g) : false;
    var out = [];
    for (var i = 0; i < products.length; i++) {
      var title = products[i].title || '';
      var n = norm(title);

      if (code && code.length >= 2 && !hasCode(n, code)) continue;
      var y = years(title), cf = chosen ? chosen.f : 0, ct = chosen ? chosen.t : 0;
      if (twoVariants && isFacelift(title) !== wantFL) {
        /* Titull pa "Facelift", po me vite qe i mbulojne te dyja versionet — "W205 Rear Diffuser (2014–2022)"
           per W205 Facelift (2018–2021) — i hyn edhe facelift-it. Kur titulli e thote "Facelift", fjala fiton. */
        var spans = wantFL && y && cf && y.f <= cf && (!ct || y.t >= ct);
        if (!spans) continue;
      }

      if (cf && y) {
        if (y.t < cf || y.f > (ct || 9999)) continue;
      }

      if (partWords && partWords.length) {
        var hit = false;
        for (var j = 0; j < partWords.length; j++) if (n.indexOf(partWords[j]) > -1) { hit = true; break; }
        if (!hit) continue;
      }

      out.push(products[i]);
    }
    return out;
  };
})();
